import { render, staticRenderFns } from "./ApiOficial.vue?vue&type=template&id=3d4c1e81"
import script from "./ApiOficial.vue?vue&type=script&lang=js"
export * from "./ApiOficial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports